import * as React from 'react';
import type { SVGProps } from 'react';
const SvgCritical = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path d="M8.607 3.671c.686-1.187 2.4-1.187 3.085 0l5.705 9.883c.686 1.187-.17 2.671-1.542 2.671H4.445c-1.371 0-2.228-1.484-1.543-2.67zm1.475 9.26a.823.823 0 1 0 .002 1.647.823.823 0 0 0-.002-1.647m-.013-6.589a.823.823 0 0 0-.81.834v3.783a.825.825 0 0 0 .823.834.825.825 0 0 0 .822-.834V7.176a.82.82 0 0 0-.835-.834" />
  </svg>
);
export default SvgCritical;
